export enum SeasonID {
  FallFest = 'fall-fest',
  Summer = 'summer',
  BackToSchool = 'back-to-school',
  WinterFest = 'winter-fest',
  SoccerStars = 'soccer-stars'
}
